import { Routes } from '@angular/router';
import { Layout } from './shared/layout/layout';
import { authGuard } from './core/guards/auth.guard';
import { Home } from './pages/home/home';
import { NotFound } from './pages/not-found/not-found';
import { Signin } from './pages/signin/signin';
import { Signup } from './pages/signup/signup';
import { Profile } from './pages/profile/profile';
import { CompanyDetails } from './shared/components/company/company-details/company-details';
import { Favorites } from './pages/favorites/favorites';
import { CompanyEdit } from './shared/components/company/company-edit/company-edit';
import { ActivationSuccess } from './pages/activation-success/activation-success';
import { Map } from './shared/components/map/map';
import { Dashboard } from './pages/dashboard/dashboard';
import { ActivationError } from './pages/activation-error/activation-error';
import { ForgotPassword } from './pages/forgot-password/forgot-password';
import { ResetPassword } from './pages/reset-password/reset-password';
import { AdminLayout } from './pages/admin/admin-layout/admin-layout';
import { AdminCompanies } from './pages/admin/admin-companies/admin-companies';
import { AdminUsers } from './pages/admin/admin-users/admin-users';
import { adminGuard } from './core/guards/admin.guard';
import { Search } from './pages/search/search';
import { MentionsLegales } from './pages/mentions-legales/mentions-legales';
import { PolitiqueConfidentialite } from './pages/politique-confidentialite/politique-confidentialite';
import { Contact } from './pages/contact/contact';

export const routes: Routes = [
    {
        path: '',
        component: Layout,
        children: [
            {
                path: '',
                component: Home,
                title:
                    'Referio - Accueil',
            },
            {
                path: 'favorites',
                canActivate: [authGuard],
                component: Favorites,
                title:
                    'Referio - Favoris',
            },
            {
                path: 'profile',
                canActivate: [authGuard],
                component: Profile,
                title: 'Referio - Mon Profil',
            },
            {
                path: 'company/:id',
                //canActivate: [authGuard],
                component: CompanyDetails,
                title: 'Referio - Détails Entreprise',
            },
            {
                path: 'company/edit/:id',
                canActivate: [authGuard],
                component: CompanyEdit,
                title: 'Referio - Modifications Entreprise',
            },
            {
                path: 'map',
                component: Map,
                title: 'Referio -  Map'
            },
            {
                path: 'search',
                component: Search,
                title: 'Referio -  Recherche'
            },
            {
                path: 'dashboard',
                component: Dashboard,
                canActivate: [authGuard],
                title: 'Referio -  Tableau de bord'
            },
            {
                path: 'admin',
                component: AdminLayout,
                canActivate: [adminGuard],
                title: 'Referio -  Panel admin',
                children: [
                    { path: '', redirectTo: 'users', pathMatch: 'full' },
                    { path: 'users', component: AdminUsers },
                    { path: 'companies', component: AdminCompanies },
                    // { path: 'reviews', component: AdminReviewsComponent },
                    // { path: 'statistics', component: AdminStatisticsComponent },
                ]
            },
            {
                path: 'mentions-legales',
                component: MentionsLegales,
                title: 'Referio -  Mentions légales'
            },
            {
                path: 'politique-confidentialite',
                component: PolitiqueConfidentialite,
                title: 'Referio -  Politique de confidentialité'
            },
            {
                path: 'contact',
                component: Contact,
                title: 'Referio -  Contact'
            },
            // auth pages
            {
                path: 'signin',
                component: Signin,
                title: 'Referio - Sign In'
            },
            {
                path: 'signup',
                component: Signup,
                title: 'Referio -  Sign Up'
            },
            {
                path: 'forgot-password',
                component: ForgotPassword,
            },
            {
                path: 'reset-password',
                component: ResetPassword,
            },
            {
                path: 'activation-success',
                component: ActivationSuccess,
            },
            {
                path: 'activation-error',
                component: ActivationError,
            },
            // error pages
            {
                path: '**',
                component: NotFound,
                title: 'Referio - 404'
            },
        ]
    },
];
